import React from "react";

import ConstData from "../../../lib/ConstData";

const Alerts = ({ kind, message, detailMessage, detailStyle, style, isPlain }) => {
    // 260804 다국어 주 메시지와 서버 상세 메시지를 안전하게 분리 표시 ... by hjkim
    const className = isPlain ? "" : "alert-area";
    const renderAlert = (kindClassName) => {
        const alertClassName = `${className} ${isPlain ? "" : kindClassName}`.trim();
        if (!detailMessage) {
            return <div className={alertClassName} style={(style ? style : {})} dangerouslySetInnerHTML={{ __html: message }}></div>;
        }

        return (
            <div className={alertClassName} style={(style ? style : {})}>
                <div dangerouslySetInnerHTML={{ __html: message }}></div>
                <div style={{ marginTop: "8px", fontSize: "75%", opacity: 0.7, whiteSpace: "pre-wrap", wordBreak: "break-word", ...(detailStyle || {}) }}>
                    {detailMessage}
                </div>
            </div>
        );
    };

    switch (kind) {
        case ConstData.ALERT_KIND.DANGER:
            return renderAlert("alert-danger");

        case ConstData.ALERT_KIND.SUCCESS:
            return renderAlert("alert-success");

        case ConstData.ALERT_KIND.WARNING:
            return renderAlert("alert-warning");

        case ConstData.ALERT_KIND.INFO:
            return renderAlert("alert-info");

        default:
            return <></>
    }
}

export default Alerts;
